"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const contactSupportButtonStyles_1 = __importDefault(require("./contactSupportButtonStyles"));
const theme_1 = __importDefault(require("../../styles/theme"));
const icon_1 = __importDefault(require("../icon/icon"));
const analytics_1 = require("../../utils/analytics/analytics");
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const ContactSupportButton = ({ onPress, text, hasIcon, eventName }) => {
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const onPressLocal = () => {
        logEventWithExtraProperties('tap_event', {
            name: eventName,
        });
        onPress();
    };
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.minimumMarginBetweenElementsVertically] },
        react_1.default.createElement(touchableElement_1.default, { style: [contactSupportButtonStyles_1.default.labelButton], eventName: eventName, onPress: onPressLocal },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow, { alignContent: 'center' }] },
                hasIcon && react_1.default.createElement(icon_1.default, { name: "faHeadset", fill: theme_1.default.colors.COLOR_PRIMARY }),
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, style: contactSupportButtonStyles_1.default.labelText }, text)))));
};
exports.default = ContactSupportButton;
